<template>
  <Teleport :to="progressHolder" v-if="progressHolder && !isMobile">
    <button
      v-for="marker in markers"
      :key="marker.bucketIndex"
      type="button"
      class="comment-timeline-marker"
      :class="{ 'comment-timeline-marker--raised': marker.raised }"
      :style="{ left: `${marker.leftPercent}%` }"
      :title="marker.commentIds.length === 1 ? 'Jump to comment' : `Jump to ${marker.commentIds.length} comments`"
      :data-testid="`comment-timeline-marker-${marker.bucketIndex}`"
      @mousedown.stop
      @touchstart.stop
      @click.stop="openMarker(marker)"
    >
      <Icon name="general.chat" size="sm" />
      <span class="comment-timeline-marker__count">{{ marker.commentIds.length }}</span>
    </button>
  </Teleport>
</template>

<script lang="ts" setup>
import { Icon } from '@/storybook';
import { useMobileDetection } from '@/composables/useMobileDetection';
import { useCommentTimeline } from '../composables/useCommentTimeline';

// Hidden on mobile for the same reason as reaction markers: the control bar has
// no responsive layout, so there is no room for pills on the progress bar.
const { isMobile } = useMobileDetection();
const { markers, openMarker, progressHolder } = useCommentTimeline();
</script>

<style scoped>
.comment-timeline-marker {
  @apply absolute bottom-full mb-1.5 flex -translate-x-1/2 cursor-pointer select-none items-center gap-1 whitespace-nowrap rounded-full border-none bg-black/70 px-2 py-1 text-sm text-white transition-transform focus:outline-none;
}

.comment-timeline-marker--raised {
  @apply mb-10;
}

.comment-timeline-marker:hover,
.comment-timeline-marker:focus-visible {
  @apply z-10 scale-125 bg-black/90;
}

.comment-timeline-marker__count {
  @apply font-semibold;
}
</style>
